/**************************************************
 * Nombre:       Tarjeta_Mixlrs
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import {useResponsive} from "../../Modulo_Responsive/Hooks/useResponsive";
import {theme} from "../../Tema";
import {formatoFechaDaysRedus} from "../../Utilidades/formatoFechaDaysRedus";
import {formatoFechaHora} from "../../Utilidades/formatoFechaHora";
import {useEffect, useState} from "react";
import {useCuentaRegresiva} from "../Secciones/Componentes/SubComponentes/Hooks/useCuentaRegresiva";
import {PlayCircleFilledOutlined} from '@mui/icons-material'
import {irUrl} from "../../Utilidades/irUrl";
import {formatoHoraSegunZona} from "../../Utilidades/formatoHoraSegunZona";


const Tarjeta_Mixlrs = ({item, escogida}) => {
    const {sCell} = useResponsive()
    const [fechaCapa, setFechaCapa] = useState('');
    const {Reloj} = useCuentaRegresiva({fecha: fechaCapa});


    useEffect(() => {

        let fecha = new Date(item.fecha);
        let fechaHora = new Date(item.hora);
        fecha.setHours(fechaHora.getHours(), fechaHora.getMinutes());
        setFechaCapa(fecha);

    }, [item])

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-end'}
            size={{xs: 12, sm: 12, md: 12}}
            spacing={0}
            sx={{
                borderBottom: escogida === item.id ? 8 : 0,
                borderColor: theme.palette.primary.main,
                borderRadius: 0
            }}
        >


            <Grid container size={{xs: 5, sm: 12, md: 4}} sx={{
                justifyContent: sCell ? 'center' : 'flex-start',
            }}>
                <img src={item.img} width={'80%'} height={'auto'} style={{borderRadius: 6}}/>

            </Grid>


            <Grid container size={{xs: 7, sm: 12, md: 8}}
                  sx={{justifyContent: 'flex-start', px: sCell ? 2 : 0, mt: sCell ? 1 : 0}}>
                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                        <Typography sx={{fontWeight: 600, fontSize: sCell ? 16 : 18, lineHeight: 1.1}}>{item.nombre}</Typography>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 0.5}}>
                        <Typography sx={{
                            fontWeight: 400,
                            fontSize: 12,
                            lineHeight: 1.1
                        }}>{`Por: ${item.participante}`}</Typography>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 0.5}}>
                        <Typography sx={{
                            fontWeight: 400,
                            fontSize: 12,
                            lineHeight: 1.1
                        }}>{`Fecha: ${formatoFechaDaysRedus(item.fecha)} - Hora ${formatoHoraSegunZona({hora: item.hora})}`}</Typography>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 1}}>
                        <Typography sx={{fontSize: 14}}>
                            {item.descripcion}
                        </Typography>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 10}}
                          sx={{justifyContent: 'flex-start', mt: 2, ml: -1.4, px: 1}}>
                        {fechaCapa && fechaCapa.getTime() > new Date().getTime() ?
                            <Reloj/>
                            :
                            <Button
                                onClick={() => irUrl(item.link)}
                                endIcon={<PlayCircleFilledOutlined/>}>
                                Escuchar
                            </Button>
                        }

                    </Grid>

                </Grid>
            </Grid>


        </Grid>
    )

}
export default Tarjeta_Mixlrs